import hotelsResults from './modules/hotelsResults';

export default {
  init() {
    // JavaScript to be fired on init
  },
  finalize() {
    // JavaScript to be fired on loaded

    hotelsResults();
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateGlobalSearchPage.js